export const HeaderLogo = [
	{
		id: 1,
		image: "./newAssets/Logo/headerLogo.svg",
		url: "./home",
	},
];

export const HeaderMenus = [
	{
		id: 1,
		title: "Home",
		url: "",
	},
	{
		id: 2,
		title: "Games",
		url: "#games",
	},
	{
		id: 3,
		title: "Working",
		url: "#howitworks",
	},
	{
		id: 4,
		title: "Cryptos",
		url: "#cryptos",
	},
	{
		id: 5,
		title: "Contacts",
		url: "#contacts",
	},
];

export const HeaderButtonLogin = [
	{
		id: 1,
		title: "LOGIN",
		url: "/login",
	},
];

export const HeaderButtonSignup = [
	{
		id: 1,
		title: "SIGNUP",
		url: "/signup",
	},
];

export const HeaderWithdrawGames = [
	{
		id: 1,
		image: "./newAssets/Icons/PlusGame.svg",
		title: "Games",
		url: "",
	},
];

export const HeaderLanguageButton = [
	{
		id: 1,
		imageLanguage: "./assets/header/Language.svg",
		title: "EN",
		imageLanguageDropdown:
			"./assets/header/LanguageDropDownBottomArrow.svg",
		imageLanguageDropdownRight:
			"./assets/header/LanguageDropDownRightArrow.svg",
		url: "/selectalanguage",
	},
];

export const HeaderCashoutButton = [
	{
		id: 1,
		title: "Cashout",
		url: "./withdraw",
	},
];

export const HeaderSettingsButton = [
	{
		id: 1,
		image: "./assets/header/Settings.svg",
		url: "",
	},
];

export const HeaderDashboardButton = [
	{
		id: 1,
		title: "LOGIN",
		url: "./login",
	},
];
